<template>
    <swiper class="swiper" :options="swiperOption">
        <swiper-slide>
            <div class="c-why-us-cont c-why-us-cont-red">
                <div class="c-why-us-image"><img src="/images/why_1.png"/></div>
                <div class="c-why-us-text" v-html="trans('Many options')"></div>
            </div>
        </swiper-slide>
        <swiper-slide>
            <div class="c-why-us-cont c-why-us-cont-blue">
                <div class="c-why-us-image"><img src="/images/why_2.png"/></div>
                <div class="c-why-us-text" v-html="trans('Nearby activities')"></div>
            </div>
        </swiper-slide>
        <swiper-slide>
            <div class="c-why-us-cont c-why-us-cont-green">
                <div class="c-why-us-image"><img src="/images/why_3.png"/></div>
                <div class="c-why-us-text" v-html="trans('Read Reviews')"></div>
            </div>
        </swiper-slide>
        <swiper-slide>
            <div class="c-why-us-cont c-why-us-cont-orange">
                <div class="c-why-us-image"><img src="/images/why_4.png"/></div>
                <div class="c-why-us-text" v-html="trans('Verified Providers')"></div>
            </div>
        </swiper-slide>
        <swiper-slide>
            <div class="c-why-us-cont c-why-us-cont-purple">
                <div class="c-why-us-image"><img src="/images/why_5.png"/></div>
                <div class="c-why-us-text" v-html="trans('Instant Booking')"></div>
            </div>
        </swiper-slide>
    </swiper>
</template>

<script>

  import {Swiper as SwiperClass, Pagination, Navigation, Mousewheel, Autoplay} from 'swiper/swiper.esm'
  import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
  import Vue from 'vue';
  SwiperClass.use([Pagination, Mousewheel, Navigation, Autoplay])
  Vue.use(getAwesomeSwiper(SwiperClass))
  const {Swiper, SwiperSlide} = getAwesomeSwiper(SwiperClass)
  import 'swiper/swiper-bundle.min.css'

  export default {
    props:["activities"],
    name: 'swiper-example-multiple-slides-per-biew',
    title: 'Multiple slides per view',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 2.25,
          spaceBetween: 14,
          freeMode: true,
          breakpoints: {
            1024: {
              slidesPerView: 5,
              noSwiping: true,
            },
            768: {
              slidesPerView: 5,
              noSwiping: true,
            }
          }
        }
      }
    }
  }
</script>